import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { disabled, form, FormField, required } from '@angular/forms/signals';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { LanguageDto, SUPPORTED_LANGUAGES } from '@workspace/data-types';
import { LanguageLabelPipe } from '../../../../../pipes/internationalization/language-iso.pipe';
import { AbstractSignalFormComponent } from '../../../../abstract';

@Component({
  selector: 'aura-internationalization-language-form',
  templateUrl: './internationalization-language.form.component.html',
  imports: [FormField, MatFormFieldModule, MatSelectModule, LanguageLabelPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraInternationalizationLanguageFormComponent extends AbstractSignalFormComponent<LanguageDto> {
  override model: WritableSignal<LanguageDto> = signal<LanguageDto>({ language: 'fr-FR' });
  supportedLanguages = SUPPORTED_LANGUAGES;

  override formTree = form(this.model, (b) => {
    required(b.language, { when: () => this.isRequired('language') });
    disabled(b.language, { when: () => this.allReadonly() || this.allDisable() });
  });
}
